import { XYChartGenericCanvasLayout } from './XYChartGenericCanvasLayout.js';
import { useSelector } from '../../core/components/overlay-tooltip/selectors.js';
import { applyOpacityToCanvas } from '../../core/utils/apply-opacity-to-canvas.js';
import { useXYChartData } from '../hooks/useXYChartData.js';
import { useXYChartHighlightedSeriesIdsState } from '../store/selectors.js';
import type { RectDatapointInternal } from '../types/xy-chart-internals.js';
import { getHighlightedSeries } from '../utils/get-highlighted-series.js';

interface XYChartHighlightedCanvasLayoutProps {
  handleOpacity: (val: string) => void;
}

export const XYChartHighlightedCanvasLayout = ({
  handleOpacity,
}: XYChartHighlightedCanvasLayoutProps) => {
  const highlightedSeriesId = useXYChartHighlightedSeriesIdsState();
  const pinned = useSelector(({ pinned }) => pinned);
  const { filteredSeriesWithDatapoints } = useXYChartData();

  handleOpacity(applyOpacityToCanvas(highlightedSeriesId));

  const highlightedSeries = getHighlightedSeries(
    filteredSeriesWithDatapoints,
    highlightedSeriesId,
  );

  if (!highlightedSeriesId || !highlightedSeries) {
    return null;
  }

  const isRectCategoryHighlighted =
    highlightedSeries.type === 'rect' && !pinned;

  // We can't use there series.id for comparison, because its creating performance issues.
  // We don't want to apply data filter when series.id doesn't have category (data.value) in id (when pinning datapoint)
  const rectDatapointFilter = isRectCategoryHighlighted
    ? (data: RectDatapointInternal) =>
        typeof data.value === 'string' &&
        highlightedSeriesId.includes(data.value)
    : undefined;

  return (
    <XYChartGenericCanvasLayout
      seriesWithDatapoints={[highlightedSeries]}
      rectFilterCallback={rectDatapointFilter}
    />
  );
};
